import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const processRagQueryForLlmContext = (payload, callback, errCallback) => {
  return async (dispatch) => {
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      const reqId = uuidv4();
      try {
        const response = await axios.post('/ads/admin/rag-query', payload, {
          params: { 'request-id': reqId },
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          if (typeof callback === 'function') callback(response?.data);
        } else {
          if (typeof errCallback === 'function') errCallback();
        }
      } catch (e) {
        console.log(e);
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default processRagQueryForLlmContext;
